import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomePage } from "./home.page";

const routes: Routes = [
    {
        path: "home",
        component: HomePage,
        children: [
            {
                path: "departure",
                loadChildren: () => import("../departure/departure.module").then(m => m.DeparturePageModule),
            },
            {
                path: "departure/:contractId/:invoiceId/:groupingCode",
                loadChildren: () => import("../departure/departure.module").then(m => m.DeparturePageModule),
            },
            {
                path: "delivery-list",
                loadChildren: () => import("../delivery/delivery-list/delivery-list.module").then(m => m.DeliveryPageModule),
            },
            {
                path: "return",
                loadChildren: () => import("../return/return.module").then(m => m.ReturnPageModule),
            },
            {
                path: "return/:contractId/:invoiceId/:groupingCode",
                loadChildren: () => import("../return/return.module").then(m => m.ReturnPageModule),
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
})
export class HomeRoutingModule {
}
